"use strict";var e=require("./index-cjs--0p_-T-4.js"),r=require("./OPMContext-cjs-D0SJ7si-.js"),t=require("@apollo/client"),o=require("./registerCustomerOnlinePaymentMethod-cjs-B7zVCy38.js"),i=require("./deliverySlotsTitle-cjs-CpjmM4oX.js");require("react"),require("react/jsx-runtime"),require("./getMeridianHour-cjs-CXeV5GPo.js");var n=t.gql`
  query GetOnlinePaymentProviderForm(
    $paymentMethodType: OnlinePaymentMethodType
  ) {
    getOnlinePaymentProviderForm(paymentMethodType: $paymentMethodType) {
      providerName
      providerConfig
    }
  }
`,a=t.gql`
  query GetOnlinePaymentProviderForm {
    getOnlinePaymentProviderForm {
      providerName
      providerConfig
    }
  }
`,s=t.gql`
  query GetAvailabilityByCart(
    $cartId: ID!
    $addressId: ID
    $start: DateTime!
    $end: DateTime!
    $express: Boolean
    $fallback: Boolean
    $acceptExtraSlot: Boolean
  ) {
    getAvailabilityByCart(
      cartId: $cartId
      addressId: $addressId
      start: $start
      end: $end
      express: $express
      fallback: $fallback
      acceptExtraSlot: $acceptExtraSlot
    ) {
      id
      from
      to
      expiresAt
    }
  }
`,d=t.gql`
  query ConfirmProviderInscriptionToken($token: String!) {
    confirmProviderInscriptionToken(token: $token) {
      cardToken
      cardBrand
      cardMask
    }
  }
`;exports.Billing=e.B,exports.EnhTotalPayV3=e.E,exports.FooterMobileV2=e.F,exports.OnePageCheckoutV3=e.O,exports.PaymentSummaryV2=e.P,exports.Receiver=e.R,exports.OPMProvider=r.O,exports.UseOPMContext=r.U,exports.registerCustomerOnlinePaymentMethod=o.r,exports.deliverySlotsTitle=i.d,exports.confirmProviderInscriptionToken=d,exports.getAvailabilityByCart=s,exports.getOnlinePaymentProvider=a,exports.getOnlinePaymentProviderv2=n;